import { empty } from './strings.js';
export const fn = 'function';
export const number = 'number';
export const password = 'password';
export const object = 'object';
export const string = 'string';
export const undef = 'undefined';
export const date = 'date';
export function getRawType(value) {
    try {
        const [toString, toLowerCase] = [Object.prototype.toString, String.prototype.toLowerCase];
        return toLowerCase.call(toString.call(value).slice(8, -1)); /* removes [object ] and leaves type */
    }
    catch (e) {
        return empty;
    }
}
//# sourceMappingURL=types.js.map